import { render, staticRenderFns } from "./tick.md?vue&type=template&id=371c555e&"
import script from "./tick.md?vue&type=script&lang=js&"
export * from "./tick.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371c555e')) {
      api.createRecord('371c555e', component.options)
    } else {
      api.reload('371c555e', component.options)
    }
    module.hot.accept("./tick.md?vue&type=template&id=371c555e&", function () {
      api.rerender('371c555e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Gauge/tick.md"
export default component.exports